import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import { property, state } from 'lit/decorators.js';
import styles from './icon.scss.js';
import { getIcon } from './download.js';
/**
 * cipublic-icon
 *
 * @fires icon.loaded - Emitted when there is an SVG is loaded successfully `{ details: { set, name, src } }`
 * @fires icon.loaderror - Emitted when there is an error loading an SVG `{ details: { url, status } }`
 *
 * TODO: added property to add role="img" if an aria-label is provided
 */
export class Icon extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * The iconset name.
         * @attr
         */
        this.set = 'default';
        /**
         * The HTML of the svg once loaded and mutated.
         */
        this.svg = '';
        /**
         * Optional property to change the size of the icon
         *
         */
        this.size = 'default';
    }
    static get styles() {
        return [styles];
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('iconset-added', this.iconsetAdded.bind(this));
        window.addEventListener('iconset-removed', this.iconsetRemoved.bind(this));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('iconset-added', this.iconsetAdded.bind(this));
        window.removeEventListener('iconset-removed', this.iconsetRemoved.bind(this));
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        this.setRoleImgAttr();
        this.setIcon();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('name') || changedProperties.has('set') || changedProperties.has('src')) {
            this.setIcon();
        }
    }
    async setIcon() {
        try {
            this.svg = await getIcon(this.set, this.name, this.src);
            this._dispatchLoaded(this.set, this.name, this.src);
        }
        catch (error) {
            this._dispatchLoadError(error.message, error.status);
            // clear any already set svg
            if (this.svg) {
                this.svg = '';
            }
        }
    }
    _dispatchLoadError(url, status) {
        const event = new CustomEvent('icon.loaderror', {
            bubbles: true,
            composed: true,
            detail: { url, status },
        });
        this.dispatchEvent(event);
    }
    _dispatchLoaded(set, name, src) {
        const event = new CustomEvent('icon.loaded', {
            bubbles: true,
            composed: true,
            detail: { set, name, src },
        });
        this.dispatchEvent(event);
    }
    iconsetAdded(event) {
        if (!this.svg) {
            if (this.set === event.detail.iconset.name) {
                this.setIcon();
            }
        }
    }
    iconsetRemoved(event) {
        if (this.svg) {
            if (this.set === event.detail.name) {
                this.setIcon();
            }
        }
    }
    setRoleImgAttr() {
        if (this.hasAttribute('aria-label') && !this.hasAttribute('role')) {
            this.setAttribute('role', 'img');
        }
    }
    render() {
        return html `${unsafeSVG(this.svg)}`;
    }
}
__decorate([
    property({ reflect: true })
], Icon.prototype, "set", void 0);
__decorate([
    property({ reflect: true })
], Icon.prototype, "name", void 0);
__decorate([
    property()
], Icon.prototype, "src", void 0);
__decorate([
    state()
], Icon.prototype, "svg", void 0);
__decorate([
    property()
], Icon.prototype, "size", void 0);
//# sourceMappingURL=icon.js.map